export interface CasinoJackpot {
    name: string;
    prize: number;
    showName: boolean;
}

export interface TotalJackpot {
    sum: number;
}

export enum CasinoJackpotType {
    Apollo = "apollo",
    Kajot = "kajot",
    Synot = "synot",
    Tech4Bet = "tech4bet",
    Adell = "adell",
    Amusnet = "amusnet",
    EGaming = "e-gaming",
    Casimi = "casimi",
    Isoftbet = "isoftbet",
    Thunderkick = "thunderkick",
    Endorphina = "endorphina",
    TomHorn = "tom horn",
}

export interface CasinoJackpotAllInfo {
    jackpotsByProvider: Record<CasinoJackpotType, CasinoJackpot[]>;
    totalJackpot: number | null | undefined;
}
